import { FullStory, init as initFullStory } from '@fullstory/browser';
import { useEffect } from 'react';

import { getFullStoryConfig } from '~ai-tutor/lib/config/clientConfig';
import { useAuth } from '~ai-tutor/lib/contexts/auth';

// We get the current fullstory consent status
const getFullstoryConsent = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
  return !!(globalThis as any).dataLayer?.[0]?.Fullstory;
};

export function FullStorySetup() {
  const { session } = useAuth();

  // Initialize FullStory once on mount
  useEffect(() => {
    const { orgId, enabled, consentId } = getFullStoryConfig();

    // Skip if FullStory is not configured
    if (!orgId || !consentId) {
      return;
    }

    // We initiate fullstory but we don't start it immediately
    // https://developer.fullstory.com/browser/fullcapture/capture-data/#manually-delay-data-capture
    window['_fs_capture_on_startup'] = false;
    initFullStory({
      orgId,
      recordCrossDomainIFrames: true,
    });

    if (getFullstoryConsent() && enabled) {
      FullStory('start');
      FullStory('trackEvent', { name: 'FS_start', properties: {} });
    }

    // We listening if the consent change
    // https://usercentrics.com/docs/web/features/events/uc-consent/
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleConsentChange = (event: any) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (event.detail.services[consentId].consent.given === true && enabled) {
        FullStory('restart');
        FullStory('trackEvent', { name: 'FS_Restart', properties: {} });
      } else {
        FullStory('shutdown');
        FullStory('trackEvent', { name: 'FS_Shutdown', properties: {} });
      }
    };

    globalThis.addEventListener('UC_CONSENT', handleConsentChange);

    return () => {
      globalThis.removeEventListener('UC_CONSENT', handleConsentChange);
    };
  }, []); // Only run once on mount

  // Update FullStory identity when session changes
  useEffect(() => {
    const { enabled, consentId } = getFullStoryConfig();
    const sessionId = session?.sessionId;

    // Only set identity if FullStory is enabled, consent is given, and we have a sessionId
    if (enabled && consentId && getFullstoryConsent() && sessionId) {
      FullStory('setIdentity', { uid: sessionId, properties: { displayName: sessionId } });
    }
  }, [session?.sessionId]);

  return <></>;
}
